import React from "react"; 
import { Link } from "react-router-dom";    
import CreateCustomerOrderForm from "./CreateCustomerOrdersForm";

const CreateCustomerOrder = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Create Customer Order</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Create Customer Order</li>
        </ul>
      </div> */}

      <CreateCustomerOrderForm />
    </>
  );
};

export default CreateCustomerOrder;
